const hasValue = (value) => value !== null && value !== undefined && value !== "";

const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const toCents = (value) => Math.round((Number(value) || 0) * 100);
const fromCents = (value) => Number((Number(value || 0) / 100).toFixed(2));

const allocateCents = (amounts = []) => {
  const normalized = amounts.map((amount, index) => {
    const rawCents = (toFiniteNumber(amount) || 0) * 100;
    const floorCents = Math.floor(rawCents + 1e-8);
    return {
      index,
      floorCents,
      fraction: rawCents - floorCents,
    };
  });
  const targetCents = toCents(amounts.reduce((sum, amount) => sum + (toFiniteNumber(amount) || 0), 0));
  let remainder = targetCents - normalized.reduce((sum, row) => sum + row.floorCents, 0);
  const allocated = normalized.map((row) => row.floorCents);

  [...normalized]
    .sort((a, b) => b.fraction - a.fraction || a.index - b.index)
    .forEach((row) => {
      if (remainder <= 0) return;
      allocated[row.index] += 1;
      remainder -= 1;
    });

  return allocated;
};

export const applyAuthoritativePoLineSubtotals = (rows = []) => {
  const nextRows = Array.isArray(rows) ? rows.map((row) => ({ ...row })) : [];
  const poLineIndexes = nextRows
    .map((row, index) => ({ row, index }))
    .filter(({ row }) => hasValue(row?._poSourceSubTotal) && row?._poPrecisionEdited !== true);

  if (!poLineIndexes.length) return nextRows;

  const allocated = allocateCents(poLineIndexes.map(({ row }) => row._poSourceSubTotal));
  poLineIndexes.forEach(({ row }, allocationIndex) => {
    const authoritativeSubTotal = fromCents(allocated[allocationIndex]);
    row._poAuthoritativeSubTotal = authoritativeSubTotal;
    row.subTotal = authoritativeSubTotal;
  });

  return nextRows;
};

export const clearAuthoritativePoSubtotal = (row = {}) => {
  const next = { ...row };
  delete next._poSourceSubTotal;
  delete next._poAuthoritativeSubTotal;
  next._poPrecisionEdited = true;
  return next;
};
